<template>
  <div class="organization" v-if="articleData">
    <div
      class="org-wrap"
      v-for="(item, index) in articleData.articleList"
      :key="index"
      @click="jumpOrg(item)"
    >
      <div class="org-img">
        <img :src="item.photoPath" />
      </div>
      <div class="org-title">
        {{ item.title }}
      </div>
    </div>

    <no-data
      :articleData="articleData"
      :loading="loading"
      v-if="!loading && !articleData"
    ></no-data>
  </div>
</template>

<script>
import NoData from '@/components/NoData';

export default {
  components: {
    NoData,
  },
  props: ['articleData'],
  jumpOrg() {},
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';

.organization {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.org-wrap {
  display: inline-block;
  margin: calc-width(10vw) 0;
}

.org-img {
  img {
    width: calc-width(160vw);
    height: calc-width(101vw);
  }
}

.org-title {
  max-width: calc-width(160vw);
  text-align: center;
  @include text-over;
  font-size: calc-width(14vw);
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Organization.vue